import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {ApiConnectService} from './api-connect.service';
import {ReportService} from './report.service';
import {GradePromotionConfirmRequest, GradePromotionEvent, GradePromotionResponse} from '../content-page/common/grade-growth/grade-growth.model';

const PROMOTIONS_PATH = '/grade-growth/promotions/';
const CONFIRM_PATH = '/confirm';
const JSON_HEADERS = new HttpHeaders({Accept: 'application/json'});
const FIRST_INDEX = 0;
const RECENT_COMMITTED_OPERATION_LIMIT = 256;

@Injectable()
export class GradePromotionService {
  private committedOperations: string[] = [];
  private committed = new Subject<GradePromotionEvent>();
  readonly promotionCommitted$ = this.committed.asObservable();

  constructor(private http: HttpClient, private api: ApiConnectService, private reports: ReportService) {}

  notifyCommitted(event: GradePromotionEvent): void {
    const key = JSON.stringify([event.employeeId, event.operationId]);
    if (this.committedOperations.indexOf(key) >= FIRST_INDEX) { return; }
    this.committedOperations.push(key);
    if (this.committedOperations.length > RECENT_COMMITTED_OPERATION_LIMIT) { this.committedOperations.shift(); }
    this.reports.invalidatePayrollReports();
    this.committed.next(event);
  }

  readOperation(userId: string, operationId: string): Observable<GradePromotionResponse> {
    return this.http.get<GradePromotionResponse>(this.operationUrl(userId, operationId), {headers: JSON_HEADERS});
  }

  confirmPromotion(userId: string, operationId: string, request: GradePromotionConfirmRequest): Observable<GradePromotionResponse> {
    const body: GradePromotionConfirmRequest = {expectedOperationRevision: request.expectedOperationRevision,
      confirmationVersion: request.confirmationVersion};
    return this.http.post<GradePromotionResponse>(this.operationUrl(userId, operationId) + CONFIRM_PATH, body,
      {headers: JSON_HEADERS});
  }

  private operationUrl(userId: string, operationId: string): string {
    return this.api.gradePromotions + encodeURIComponent(userId) + PROMOTIONS_PATH + encodeURIComponent(operationId);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/grade-promotion.service.ts